import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { CheckIcon } from "@heroicons/react/24/outline";
import { updatedProgress } from "@registrationaction";
import { classNames } from "@utilscommon";
import { handleShowHide } from "@fieldshowhide";
import FixedFields from "@formfixedfield";
import SessionRSVP from "@rsvpsessionsfield";
import SectionList from "@formsection";
import LocaleStrings from "@language";
import toast from "react-hot-toast";
import CompanyDetails from "@companydetails";

const SectionWisePage = (props) => {
  const {
    autofill,
    formValues,
    formErrors,
    btnLoading,
    pristine,
    invalid,
    submitting,
    source,
    checkoutFormData,
    sectionWiseArray,
    activeSteps,
    steps,
    lastFieldUpdated,
    allConditionalFields,
    eventSettingsData,
    generalRSVPSessions,
  } = props;
  const [previousStep, setPreviousStep] = useState({});
  const [currentStep, setCurrentStep] = useState({
    name: "profiledetails",
    status: "current",
    ishidden: 0,
  });
  let formlayout = checkoutFormData?.data?.formlayout ?? "";
  const divRef = useRef(null);
  const custom_settings = JSON.parse(
    eventSettingsData?.data?.custom_settings ?? "{}"
  );
  const rsvpMandatory = custom_settings?.rsvp_mandatory ?? false;

  // console.log("sectionWiseArray :- ", sectionWiseArray);
  // console.log("steps :- ", steps);
  // console.log("formlayout :- ", formlayout);
  // console.log("formErrors :- ", formErrors);

  const handleContinue = (obj, action) => {
    // console.log("obj :- ", obj);
    if (!disabled || action === "previous") {
      let index = _.findIndex(activeSteps, (e) => {
        return e.name === obj.name;
      });
      // console.log("index :- ", index);
      setPreviousStep({});
      setCurrentStep({});

      if (action === "continue") {
        _.map(activeSteps, (o, i) => {
          if (i <= index) {
            o.status = "complete";
            if (i === index) {
              setPreviousStep(o);
            }
          } else if (i === index + 1) {
            o.status = "current";
            setCurrentStep(o);
          } else {
            o.status = "";
          }
        });
      } else if (action === "previous") {
        _.map(activeSteps, (o, i) => {
          if (i < index) {
            o.status = "complete";
            if (i === index - 1) {
              setPreviousStep(o);
            }
          } else if (i === index) {
            o.status = "current";
            setCurrentStep(o);
          } else {
            o.status = "";
          }
        });
      }

      let newSteps = [];
      _.map(steps, (s) => {
        let match = _.filter(activeSteps, (as) => as?.name === s?.name);

        if (match?.length > 0) {
          s.status = match[0].status;
          s.ishidden = match[0].ishidden;
        }

        newSteps.push(s);
      });

      props.updatedProgress(newSteps);
    } else {
      if (divRef?.current) {
        divRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      toast.error(LocaleStrings.kRequiredFieldAlert);
    }
  };

  const handleSubmit = () => {
    if (_.isEmpty(formErrors)) {
      props.formSubmit(formValues);
    } else {
      handlebeforesubmit();
      toast.error(LocaleStrings.kRequiredFieldAlert);
    }
  };
  const handlebeforesubmit = () => {
    if (divRef?.current) {
      divRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderNavbar = () => {
    return (
      <>
        <nav aria-label="Progress">
          <ol role="list" className="flex items-center">
            {activeSteps.map((step, stepIdx) => (
              <li
                key={step.name}
                className={classNames(
                  stepIdx !== activeSteps.length - 1 ? "pr-8 sm:pr-20" : "",
                  "relative"
                )}
              >
                {step.status === "complete" ? (
                  <>
                    <div
                      className="absolute inset-0 flex items-center"
                      aria-hidden="true"
                    >
                      <div className="h-0.5 w-full bg-themeLight" />
                    </div>
                    <div
                      className="relative flex h-8 w-8 items-center justify-center rounded-full bg-theme cursor-pointer"
                      onClick={() => handleContinue(step, "previous")}
                    >
                      <CheckIcon
                        className="h-5 w-5 text-white"
                        aria-hidden="true"
                      />
                      <span className="sr-only">{step.name}</span>
                    </div>
                  </>
                ) : step.status === "current" ? (
                  <>
                    <div
                      className="absolute inset-0 flex items-center"
                      aria-hidden="true"
                    >
                      <div className="h-0.5 w-full bg-gray-200" />
                    </div>
                    <div
                      className="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-theme bg-white"
                      aria-current="step"
                    >
                      <span
                        className="h-2.5 w-2.5 rounded-full bg-theme"
                        aria-hidden="true"
                      />
                      <span className="sr-only">{step.name}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="absolute inset-0 flex items-center"
                      aria-hidden="true"
                    >
                      <div className="h-0.5 w-full bg-gray-200" />
                    </div>
                    <div className="group relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400">
                      <span
                        className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300"
                        aria-hidden="true"
                      />
                      <span className="sr-only">{step.name}</span>
                    </div>
                  </>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </>
    );
  };
  // const handlebeforesubmit = () => {
  //   if (!_.isEmpty(formErrors)) {
  //     console.log("registration-call");
  //     setTimeout(() => {
  //       window.scrollTo({ top: 0, behavior: "smooth" });
  //     }, 0);
  //   }
  // };

  const renderSection = () => {
    return _.map(sectionWiseArray, (section) => {
      let name = section?.name;
      let match = _.filter(activeSteps, (e) => {
        return e.name === name;
      });

      // console.log("match to display :- ", match);

      return match?.[0]?.status === "current" ? (
        <SectionList
          key={section?.name}
          source={source}
          section={section}
          autofill={autofill}
          formValues={formValues}
          formErrors={formErrors}
          divRef={divRef}
        />
      ) : (
        ""
      );
    });
  };

  const renderSinglePageSections = () => {
    // console.log("lastFieldUpdated :- ", lastFieldUpdated);
    // console.log("formValues :- ", formValues);

    let renderFieldsArr = [];
    for (let pi = 0; pi < sectionWiseArray?.length; pi++) {
      let field = sectionWiseArray[pi];
      let name = field?.name;

      let ishidden = handleShowHide(
        name,
        formValues,
        autofill,
        lastFieldUpdated,
        allConditionalFields
        // sectionWiseArray
      );

      // console.log("section ishidden :- ", name, ishidden);
      // console.log("-------------------");

      if (ishidden === 0)
        renderFieldsArr.push(
          <SectionList
            key={name}
            source={source}
            section={field}
            autofill={autofill}
            formValues={formValues}
            divRef={divRef}
            formErrors={formErrors}
          />
        );
    }

    // console.log("renderFieldsArr :- ", renderFieldsArr);
    return renderFieldsArr;
  };

  // console.log("currentStep :- ", currentStep);
  // console.log("previousStep :- ", previousStep);

  // Check is this last section
  let currentSectionIndex = _.findIndex(activeSteps, (o) => {
    return o?.name === currentStep?.name;
  });

  // Check company info page required
  let companyinfo = _.filter(steps, (o) => o.name === "companyinfo");

  // Check session rsvp page required
  let sessionRSVPPage = _.filter(steps, (o) => o.name === "sessionrsvp");

  // console.log("sessionRSVPPage :- ", sessionRSVPPage);
  // console.log("activeSteps :- ", activeSteps);
  // console.log("total :- ", activeSteps.length);
  // console.log("currentIndex :- ", currentSectionIndex);
  // console.log("currentStep :- ", currentStep);
  // console.log("------------------------------------");

  // Logic to disable continue button, if any field error in current step, then disabled the continue button
  let disabled = false;
  if (currentStep?.name === "profiledetails") {
    if (
      formErrors?.profileurl ||
      formErrors?.firstname ||
      formErrors?.lastname ||
      formErrors?.email
    ) {
      disabled = true;
    }
  } else {
    let currentMatch = _.filter(sectionWiseArray, (obj) => {
      return obj?.name === currentStep?.name;
    });
    // console.log("currentMatch :- ", currentMatch);
    if (currentMatch?.length > 0) {
      let matchStepFields = _.map(currentMatch?.[0]?.elements, (o) => o?.name);
      // console.log("matchStepFields :- ", matchStepFields);

      matchStepFields.forEach((o) => {
        if (formErrors?.[o]) {
          disabled = true;
        }
      });
    }
    if (currentStep?.name === "companyinfo" && formErrors?.companyinfo) {
      disabled = true;
    }
  }

  return (
    <>
      <div className="base-form">
        {formlayout === "sectionwise" ? (
          <>
            {/* Section with Multiple Page */}
            <div className="flex justify-center mb-2">{renderNavbar()}</div>

            {currentStep?.name === "profiledetails" &&
            currentStep?.status === "current" ? (
              <div className="rounded-xl border border-default">
                <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                  <div className="custom-text-primary-md-medium">
                    {LocaleStrings.kProfileSectionTitle}
                  </div>
                  <div
                    className="custom-text-secondary-sm-medium"
                    ref={
                      ["email", "lastname", "firstname", "profileurl"]?.some(
                        (key) => key in formErrors
                      )
                        ? divRef
                        : null
                    }
                  >
                    {LocaleStrings.kProfileSectionDesc}
                  </div>
                </div>
                <dl className="base-form px-6 py-4">
                  <FixedFields
                    source={source}
                    autofill={props.autofill}
                    formValues={formValues}
                  />
                </dl>
              </div>
            ) : currentStep?.name === "companyinfo" &&
              currentStep?.status === "current" ? (
              <CompanyDetails />
            ) : currentStep?.name === "sessionrsvp" &&
              currentStep?.status === "current" ? (
              <div className="rounded-xl border border-default">
                <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                  <div className="custom-text-primary-md-medium">
                    {LocaleStrings.kSessionRSVPSectionTitle}
                    {rsvpMandatory && (
                      <span className="label-mandatory">*</span>
                    )}
                  </div>
                  <div className="custom-text-secondary-sm-medium">
                    {LocaleStrings.kSessionRSVPSectionDesc}
                  </div>
                </div>
                <dl className="base-form px-6 py-4">
                  <SessionRSVP
                    autofill={autofill}
                    formValues={formValues}
                    RSVPSessionsData={generalRSVPSessions?.data}
                    eventSettingsData={eventSettingsData?.data}
                  />
                </dl>
              </div>
            ) : (
              <>{renderSection()}</>
            )}

            <div className="flex items-center justify-between">
              {previousStep.hasOwnProperty("name") ? (
                <button
                  type="button"
                  className="default-button-md"
                  onClick={() => handleContinue(previousStep, "previous")}
                  // disabled={invalid}
                >
                  {LocaleStrings.kPreviousText}
                </button>
              ) : (
                <div></div>
              )}

              {currentSectionIndex === activeSteps?.length - 1 ? (
                <button
                  type="button"
                  onClick={() => handleSubmit()}
                  className="theme-button-md"
                  // disabled={pristine || invalid || submitting || btnLoading}
                >
                  <svg
                    className={classNames(
                      btnLoading ? "" : "hidden",
                      "cust-btn-spinner"
                    )}
                    viewBox="0 0 1024 1024"
                    focusable="false"
                    data-icon="btnloading"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                  </svg>{" "}
                  {LocaleStrings.kRegisterText}
                </button>
              ) : (
                <button
                  type="button"
                  className="default-button-md"
                  onClick={() => handleContinue(currentStep, "continue")}
                  // disabled={disabled}
                >
                  {LocaleStrings.kContinueText}
                </button>
              )}
            </div>
          </>
        ) : (
          <>
            {/* Section with Single Page */}
            {source !== "proposal" ? (
              <div className="rounded-xl border border-default">
                <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                  <div className="custom-text-primary-md-medium">
                    {LocaleStrings.kProfileSectionTitle}
                  </div>
                  <div className="custom-text-secondary-sm-medium">
                    {LocaleStrings.kProfileSectionDesc}
                  </div>
                </div>
                <dl
                  className="base-form px-6 py-4"
                  ref={
                    ["email", "lastname", "firstname", "profileurl"]?.some(
                      (key) => key in formErrors
                    )
                      ? divRef
                      : null
                  }
                >
                  <FixedFields
                    source={source}
                    autofill={autofill}
                    formValues={formValues}
                  />
                </dl>
              </div>
            ) : (
              ""
            )}

            {renderSinglePageSections()}

            {companyinfo.length > 0 ? <CompanyDetails /> : ""}

            {sessionRSVPPage.length > 0 ? (
              <div className="rounded-xl border border-default">
                <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                  <div className="custom-text-primary-md-medium">
                    {LocaleStrings.kSessionRSVPSectionTitle}
                    {rsvpMandatory && (
                      <span className="label-mandatory">*</span>
                    )}
                  </div>
                  <div className="custom-text-secondary-sm-medium">
                    {LocaleStrings.kSessionRSVPSectionDesc}
                  </div>
                </div>
                <dl className="base-form px-6 py-4">
                  <SessionRSVP
                    autofill={autofill}
                    formValues={formValues}
                    RSVPSessionsData={generalRSVPSessions?.data}
                    eventSettingsData={eventSettingsData?.data}
                  />
                </dl>
              </div>
            ) : (
              ""
            )}

            <div className="flex items-center justify-end">
              <button
                type="submit"
                className="theme-button-md"
                // disabled={
                //   source === "proposal"
                //     ? pristine || invalid || submitting || btnLoading
                //     :
                //     false
                // }
                onClick={handlebeforesubmit}
              >
                <svg
                  className={classNames(
                    btnLoading ? "" : "hidden",
                    "cust-btn-spinner"
                  )}
                  viewBox="0 0 1024 1024"
                  focusable="false"
                  data-icon="btnloading"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                </svg>{" "}
                {source === "proposal"
                  ? LocaleStrings.kSaveText
                  : LocaleStrings.kRegisterText}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  let activeSteps = _.filter(state.progressArray, (s) => {
    return s?.ishidden === 0;
  });

  return {
    checkoutFormData: state.checkoutFormData,
    sectionWiseArray: state.sectionWiseFormArray,
    activeSteps,
    steps: state.progressArray,
    lastFieldUpdated: state.lastFieldUpdated,
    allConditionalFields: state.allConditionalFields,
    eventSettingsData: state.eventSettingsData,
    generalRSVPSessions: state.generalRSVPSessions,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updatedProgress }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SectionWisePage);
